import { useReadContracts } from "wagmi"

import { bridge, ETHEREUM_CHAIN_ID } from "#/shared/constants"
import { MezoBridge } from "#/shared/constants/artifacts"
import { BridgeableTokens, bridgeableTokens } from "#/shared/types"

// Exclude from the list BTC. The BTC should use the const value hardcoded in
// the codebase `BITCOIN_MIN_DEPOSIT`
const ERC20_TOKENS = bridgeableTokens.filter((token) => token !== "BTC")

const DEFAULT_VALUES = ERC20_TOKENS.reduce(
  (acc, token) => ({ ...acc, [token]: 0n }),
  {},
) as Record<Exclude<BridgeableTokens, "BTC">, bigint>

// Exclude from the list tBTC. The tBTC token has its own function
// (`minTBTCAmount`).
const ERC20_TOKENS_WITHOUT_TBTC = ERC20_TOKENS.filter(
  (token) => token !== "tBTC",
)

const contracts = ERC20_TOKENS_WITHOUT_TBTC.map((token) => ({
  abi: MezoBridge.abi,
  address: MezoBridge.address,
  chainId: ETHEREUM_CHAIN_ID,
  functionName: "ERC20Tokens",
  args: [bridge.BRIDGEABLE_TOKENS[token].sourceToken],
}))

contracts.push({
  abi: MezoBridge.abi,
  address: MezoBridge.address,
  chainId: ETHEREUM_CHAIN_ID,
  functionName: "minTBTCAmount",
  args: [],
})

const orderOfResultsByTokenName = [...ERC20_TOKENS_WITHOUT_TBTC, "tBTC"]

export default function useERC20Tokens() {
  const { data: minERC20Tokens, ...rest } = useReadContracts({
    contracts,
    query: {
      // Data fetched only once
      staleTime: Infinity,
      gcTime: Infinity,
    },
  })

  const data = minERC20Tokens
    ? orderOfResultsByTokenName.reduce((acc, token, index) => {
        const { result, status } = minERC20Tokens[index]

        if (status === "failure") return acc

        return { ...acc, [token]: result }
      }, DEFAULT_VALUES)
    : DEFAULT_VALUES

  return {
    data,
    ...rest,
  }
}
